/* Verolae · Countdown timer
   Reproduces the source site header countdown.
   Source behaviour: `let totalSeconds = 2 * 60 * 60` on DOMContentLoaded, decremented once per
   second, rendered as zero-padded total hours / minutes / seconds, clamped at 0 (the bar stays
   visible showing 00 / 00 / 00). Nothing is persisted, so every page load restarts at 02:00:00.
   Defaults reproduce exactly that; the data-* attributes make the deadline, the expiry
   behaviour and per-visitor persistence configurable from the theme editor. */
(function () {
  if (window.customElements.get('verolae-countdown-timer')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* Accepts "YYYY-MM-DD", "YYYY-MM-DD HH:MM", "YYYY-MM-DD HH:MM:SS", optionally followed by
     "Z" or "+10:00" / "+1000". Without an offset the value is the visitor's local time. */
  function parseEndTime(value) {
    if (!value) return NaN;
    var s = String(value).trim().replace(/\s+/g, ' ');
    var m = s.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{1,2}:\d{2})(?::(\d{2}))?)?\s*(Z|[+-]\d{2}:?\d{2})?$/i);
    if (!m) return Date.parse(s);
    var time = m[2] || '00:00';
    if (time.length === 4) time = '0' + time;
    var iso = m[1] + 'T' + time + ':' + (m[3] || '00');
    if (m[4]) iso += m[4].toUpperCase().replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
    return Date.parse(iso);
  }

  class VerolaeCountdownTimer extends HTMLElement {
    connectedCallback() {
      this.els = {
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]')
      };
      if (!this.els.hours || !this.els.minutes || !this.els.seconds) return;

      this.mode = this.dataset.mode === 'end_time' ? 'end_time' : 'duration';
      this.duration = Math.max(0, parseInt(this.dataset.duration, 10) || 0);
      this.expiryAction = this.dataset.expiry || 'zeros';
      // Never persist inside the theme editor so merchants always preview a fresh timer.
      this.remember = this.dataset.remember === 'true' && !(window.Shopify && window.Shopify.designMode);
      this.storageKey = 'verolae-countdown-timer:' + (this.dataset.sectionId || '') + ':' + this.duration;

      if (this.mode === 'end_time') {
        this.deadline = parseEndTime(this.dataset.end);
        if (isNaN(this.deadline)) this.mode = 'duration'; // empty/invalid date -> rolling duration
      }
      if (this.mode === 'duration') this.deadline = this.rollingDeadline(false);

      this.expired = false;
      this.style.display = '';
      this.stop();
      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    /* Deadline for the rolling mode: now + duration (source behaviour). With "remember" on, the
       deadline is stored per visitor so reloads/navigation continue the same countdown. */
    rollingDeadline(forceNew) {
      var now = Date.now();
      if (this.remember && !forceNew) {
        var stored = NaN;
        try {
          stored = parseInt(window.localStorage.getItem(this.storageKey), 10);
        } catch (e) {
          /* storage unavailable */
        }
        if (!isNaN(stored) && (stored > now || this.expiryAction !== 'restart')) return stored;
      }
      var deadline = now + this.duration * 1000;
      if (this.remember) {
        try {
          window.localStorage.setItem(this.storageKey, String(deadline));
        } catch (e) {
          /* storage unavailable */
        }
      }
      return deadline;
    }

    tick() {
      var remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.render(remaining);
      if (remaining <= 0) this.onExpire();
    }

    /* Same arithmetic as the source: total hours (not capped at 24), minutes, seconds. */
    render(totalSeconds) {
      var hrs = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;
      this.els.hours.textContent = pad(hrs);
      this.els.minutes.textContent = pad(mins);
      this.els.seconds.textContent = pad(secs);
    }

    onExpire() {
      if (this.expiryAction === 'restart' && this.mode === 'duration' && this.duration > 0) {
        this.deadline = this.rollingDeadline(true);
        return;
      }
      if (this.expired) return;
      this.expired = true;
      this.stop();
      if (this.expiryAction === 'hide') this.style.display = 'none';
      /* 'zeros' (source behaviour): keep the bar visible at 00 / 00 / 00 */
    }
  }

  window.customElements.define('verolae-countdown-timer', VerolaeCountdownTimer);
})();
